module.exports = __webpack_public_path__ + "images/backgrounds/cosmos/small.c5492f33113601649156.jpg";